import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { DirectivesModule } from "src/app/directives.module";
@Component({
  selector: 'app-availability-chart',
  standalone: true,
  imports: [DirectivesModule],
  templateUrl: './availability-chart.component.html',
  styleUrl: './availability-chart.component.scss',
})
export class AvailabilityChartComponent {
  @Input() sendProfileComData: any;
  constructor(private router: Router) {}

  // SVG arc path for progress ring
  getProfileProgressArc(percent?: number): string {
    const r = 47;
    const cx = 60;
    const cy = 60;
    // Use argument if provided, else fallback to this.profileCompletion
    const pct =
      percent !== undefined
        ? Math.max(0, Math.min(100, percent))
        : Math.max(0, Math.min(100, this.profileCompletion));
    if (pct === 100) {
      // Full circle: draw two arcs to ensure visibility
      const start = this.polarToCartesian(cx, cy, r, 90);
      const mid = this.polarToCartesian(cx, cy, r, 270);
      return [
        'M',
        start.x,
        start.y,
        'A',
        r,
        r,
        0,
        1,
        1,
        mid.x,
        mid.y,
        'A',
        r,
        r,
        0,
        1,
        1,
        start.x,
        start.y,
      ].join(' ');
    }
    const angle = (pct / 100) * 360;
    // Start at top (12 o'clock)
    const startAngle = 90; // 0 degrees is at 3 o'clock, so -90 starts at 12 o'clock
    const endAngle = startAngle + angle;

    // Convert angles to radians
    const start = this.polarToCartesian(cx, cy, r, startAngle);
    const end = this.polarToCartesian(cx, cy, r, endAngle);

    const largeArcFlag = pct > 50 ? 1 : 0;

    return [
      'M',
      start.x,
      start.y,
      'A',
      r,
      r,
      0,
      largeArcFlag,
      1,
      end.x,
      end.y,
    ].join(' ');
  }

  polarToCartesian(cx: number, cy: number, r: number, angle: number) {
    const rad = ((angle - 90) * Math.PI) / 180.0;
    return {
      x: cx + r * Math.cos(rad),
      y: cy + r * Math.sin(rad),
    };
  }
  profileCompletion = 15; // percent, set to 15 for your example
  goToCalendar() {
    this.router.navigate(['teacher/calendar']);
  }
  getSmallProfileDashOffset(availability_health: number): string {
    const r = 35;
    const circumference = 2 * Math.PI * r;
    var adjustedHealth = 100 - availability_health; // Adjusted to subtract 100
    const percent = Math.max(0, Math.min(100, adjustedHealth));
    const offset = circumference - (circumference * percent) / 100;
    return offset.toFixed(3);
  }

  getSmallProfileDashArray(_availability_health?: number): string {
    const r = 35;
    return (2 * Math.PI * r).toFixed(3);
  }

  getProfileProgressDashOffset(): string {
    // Calculate offset based on profileCompletion, always >= 0
    const percent = Math.max(0, Math.min(100, this.profileCompletion));
    const circumference = parseFloat(
      AvailabilityChartComponent.PROFILE_RING_CIRCUMFERENCE
    );
    const offset = circumference - (circumference * percent) / 100 - 100;
    return offset.toFixed(3);
  }
  getProfileProgressDashArray(): string {
    // Return the circumference for the SVG ring
    return AvailabilityChartComponent.PROFILE_RING_CIRCUMFERENCE;
  }
  static PROFILE_RING_CIRCUMFERENCE = (2 * Math.PI * 35).toFixed(3); // r=35
}
